<!-- Switch Input -->
<div class="w-full"
     [class.field]="formField">
  @if (labelTop && label) {
    <label
      id="{{ name }}_label"
      class="flex flex-grow-1"
      [class.mb-2]="!formField"
      for="{{ name }}">
      <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
        {{ label | translate }}
      </span>
    </label>
  }
  <div class="flex align-items-center p-2 h-full">
    @if (model !== undefined) {
      <p-inputSwitch inputId="{{ name }}"
        ariaLabelledBy="{{ name }}_label"
        styleClass="{{ inputClass }}"
        [disabled]="disabled"
        [ngModel]="model"
        [ngModelOptions]="{standalone: true}"
        (onChange)="valueChange.emit($event)">
      </p-inputSwitch>
    }
    @if (!labelTop && label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1 ml-2"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
  </div>
</div>
